import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


/**
   * Logger Factory
   * @namespace increment: is the value to increment
   * @namespace counterValue: is the current value to brought to his parent
   * <ute-counter (counterValue)="test($event)" increment="0.25" ></ute-counter>
*/

@Component({
  selector: 'ute-counter',
  templateUrl: 'ute-counter.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(()=> UteCounterComponent),
    multi: true
  }]
})
export class UteCounterComponent  {
  @Input()  increment: any = 0.25;
  @Input()  initialValue: number;
  @Output() counterValue = new EventEmitter;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  public counter = 0;
  public step: number;
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };
  public value: string = '';

  constructor() {
   
  }

  ngOnInit(){
    this.step = parseFloat(this.increment);
    if(this.initialValue){
      this.counter = this.initialValue;
    }
  }

  minus(){
    if(this.counter > 0){
      this.counter -= this.step;
    }
  }
  plus(){
    this.counter += this.step;
  }

  onChangeValue(event){
    const value = parseFloat(event.value);
    this.counter = value;
    this.propagateChange(this.value); 
    this.counterValue.emit(event.value);
  }

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }
  public writeValue(obj: any) {
    if(obj) {
      this.value = obj;
    } 
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-counter/ute-counter.component.ts